import { post, get, DELETE } from '../axios'

// 启用/禁用运费规则(国家)
export function freight_activeCountryRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/activeCountryRule`,
    map,
    option
  ).then(response => response)
}

// 新增运费配置（国家）
export function freight_addCountryRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/addCountryRule`,
    map,
    option
  ).then(response => response)
}

// 删除运费配置（国家）
export function freight_delCountryRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/delCountryRule`,
    map,
    option
  ).then(response => response)
}

// 删除运费配置（省州）
export function freight_delStateRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/delStateRule`,
    map,
    option
  ).then(response => response)
}

// 编辑运费配置（省州）
export function freight_editStateRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/editStateRule`,
    map,
    option
  ).then(response => response)
}

// 查询运费列表（API）
export function freight_queryFreightRuleList_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/queryFreightRuleList`,
    map,
    option
  ).then(response => response)
}

// 查询运费列表（省州）
export function freight_queryStateRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/queryStateRule`,
    map,
    option
  ).then(response => response)
}

// 查询国家列表
export function common_queryCountryInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/common/queryCountryInfo`,
    map,
    option
  ).then(response => response)
}

// 查询四要素列表
export function common_querySiteInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/common/querySiteInfo`,
    map,
    option
  ).then(response => response)
}

// 查询省州列表
export function common_queryStateInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/common/queryStateInfo`,
    map,
    option
  ).then(response => response)
}

// 查询运费详情（API）
export function freight_queryFreightRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/queryFreightRule`,
    map,
    option
  ).then(response => response)
}

// 查询配置列表（根据四要素）
export function setting_queryByFourElement_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/setting/queryByFourElement`,
    map,
    option
  ).then(response => response)
}

// 查询操作日志
export function setting_queryOptLog_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/setting/queryOptLog`,
    map,
    option
  ).then(response => response)
}

// 查询配置列表（根据配置id）
export function setting_querybyId_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/setting/querybyId`,
    map,
    option
  ).then(response => response)
}

// 新增/编辑配置
export function setting_upsert_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/setting/upsert`,
    map,
    option
  ).then(response => response)
}

// 删除配置
export function setting_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/setting/delete`,
    map,
    option
  ).then(response => response)
}

// 查询语言列表
export function common_queryLanguageInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/common/queryLanguageInfo`,
    map,
    option
  ).then(response => response)
}

// 新增运费配置（省州）
export function freight_addStateRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/addStateRule`,
    map,
    option
  ).then(response => response)
}

// 查询运费列表（国家）
export function freight_queryCountryRule_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/queryCountryRule`,
    map,
    option
  ).then(response => response)
}

// 查询运费详情（省州）
export function freight_queryStateRuleDetail_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/freight/queryStateRuleDetail`,
    map,
    option
  ).then(response => response)
}

// 删除问题
export function faq_deleteQa_post(map, option) {
  return post(`${process.env.VUE_APP_HOMEPAGE}/faq/deleteQa`, map, option).then(
    response => response
  )
}

// 删除标题
export function faq_deleteTitle_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/faq/deleteTitle`,
    map,
    option
  ).then(response => response)
}

// 修改问题顺序
export function faq_modifyPosition_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/faq/modifyPosition`,
    map,
    option
  ).then(response => response)
}

// 查询标题下问题列表
export function faq_queryQa_post(map, option) {
  return post(`${process.env.VUE_APP_HOMEPAGE}/faq/queryQa`, map, option).then(
    response => response
  )
}

// 查询标题列表
export function faq_queryTitle_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/faq/queryTitle`,
    map,
    option
  ).then(response => response)
}

// 新增/编辑问题
export function faq_upsertQa_post(map, option) {
  return post(`${process.env.VUE_APP_HOMEPAGE}/faq/upsertQa`, map, option).then(
    response => response
  )
}

// 新增/编辑标题
export function faq_upsertTitle_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/faq/upsertTitle`,
    map,
    option
  ).then(response => response)
}

// 上传文件
export function common_uploadFile_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/common/uploadFile`,
    map,
    option
  ).then(response => response)
}

// 修改标题顺序
export function faq_modifyTitlePosition_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/faq/modifyTitlePosition`,
    map,
    option
  ).then(response => response)
}

// 查询四要素集合
export function common_querySiteInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/common/querySiteInfo`,
    map,
    option
  ).then(response => response)
}

// 删除标签
export function activityTag_deleteTag_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/activityTag/deleteTag`,
    map,
    option
  ).then(response => response)
}

// 查询标签详情
export function activityTag_queryTagDetail_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/activityTag/queryTagDetail`,
    map,
    option
  ).then(response => response)
}

// 查询标签列表
export function activityTag_queryTagList_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/activityTag/queryTagList`,
    map,
    option
  ).then(response => response)
}

// 新增/编辑标签
export function activityTag_upsertTag_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/activityTag/upsertTag`,
    map,
    option
  ).then(response => response)
}

// 查询问答列表（C端用）
export function faq_queryFqa_post(map, option) {
  return post(`${process.env.VUE_APP_HOMEPAGE}/faq/queryFqa`, map, option).then(
    response => response
  )
}

// 调整标签顺序
export function activityTag_modifyTagPosition_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/activityTag/modifyTagPosition`,
    map,
    option
  ).then(response => response)
}

// 新增home banner
export function homepage_material_homebanner_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homebanner/add`,
    map,
    option
  ).then(response => response)
}

// 删除home banner
export function homepage_material_homebanner_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homebanner/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// home banner详情
export function homepage_material_homebanner_detail_materialId_get(
  map,
  option
) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homebanner/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑home banner
export function homepage_material_homebanner_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homebanner/edit`,
    map,
    option
  ).then(response => response)
}

// home banner列表
export function homepage_material_homebanner_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homebanner/list`,
    map,
    option
  ).then(response => response)
}

// 新增活动banner
export function homepage_material_activitybanner_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/activitybanner/add`,
    map,
    option
  ).then(response => response)
}

// 删除活动banner
export function homepage_material_activitybanner_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/activitybanner/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 活动banner详情
export function homepage_material_activitybanner_detail_materialId_get(
  map,
  option
) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/activitybanner/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑活动banner
export function homepage_material_activitybanner_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/activitybanner/edit`,
    map,
    option
  ).then(response => response)
}

// 活动banner列表
export function homepage_material_activitybanner_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/activitybanner/list`,
    map,
    option
  ).then(response => response)
}

// 新增频道位配置
export function homepage_material_channel_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/channel/add`,
    map,
    option
  ).then(response => response)
}

// 删除频道位配置
export function homepage_material_channel_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/channel/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 频道位配置详情
export function homepage_material_channel_detail_materialId_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/channel/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑频道位配置
export function homepage_material_channel_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/channel/edit`,
    map,
    option
  ).then(response => response)
}

// 频道位配置列表
export function homepage_material_channel_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/channel/list`,
    map,
    option
  ).then(response => response)
}

// 新增资源位配置
export function homepage_material_resource_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/resource/add`,
    map,
    option
  ).then(response => response)
}

// 删除资源位配置
export function homepage_material_resource_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/resource/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 资源位配置详情
export function homepage_material_resource_detail_materialId_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/resource/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑资源位配置
export function homepage_material_resource_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/resource/edit`,
    map,
    option
  ).then(response => response)
}

// 资源位配置列表
export function homepage_material_resource_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/resource/list`,
    map,
    option
  ).then(response => response)
}

// 站点列表（组合id）
export function site_list_get(map, option) {
  return get(`${process.env.VUE_APP_HOMEPAGE}/site/list`, map, option).then(
    response => response
  )
}

// collection列表
export function collection_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/collection/list`,
    map,
    option
  ).then(response => response)
}

// 新增品类营销位
export function homepage_material_categorymarketingposition_add_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/categorymarketingposition/add`,
    map,
    option
  ).then(response => response)
}

// 删除品类营销位
export function homepage_material_categorymarketingposition_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/categorymarketingposition/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 品类营销位详情
export function homepage_material_categorymarketingposition_detail_materialId_get(
  map,
  option
) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/categorymarketingposition/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑品类营销位
export function homepage_material_categorymarketingposition_edit_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/categorymarketingposition/edit`,
    map,
    option
  ).then(response => response)
}

// 品类营销位列表
export function homepage_material_categorymarketingposition_list_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/categorymarketingposition/list`,
    map,
    option
  ).then(response => response)
}

// 新增专题合集A
export function homepage_material_subjectA_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectA/add`,
    map,
    option
  ).then(response => response)
}

// 删除专题合集A
export function homepage_material_subjectA_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectA/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 专题合集A详情
export function homepage_material_subjectA_detail_materialId_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectA/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑专题合集A
export function homepage_material_subjectA_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectA/edit`,
    map,
    option
  ).then(response => response)
}

// 专题合集A列表
export function homepage_material_subjectA_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectA/list`,
    map,
    option
  ).then(response => response)
}

// 新增专题合集B
export function homepage_material_subjectB_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectB/add`,
    map,
    option
  ).then(response => response)
}

// 删除专题合集B
export function homepage_material_subjectB_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectB/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 专题合集B详情
export function homepage_material_subjectB_detail_materialId_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectB/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑专题合集B
export function homepage_material_subjectB_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectB/edit`,
    map,
    option
  ).then(response => response)
}

// 专题合集B列表
export function homepage_material_subjectB_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/subjectB/list`,
    map,
    option
  ).then(response => response)
}

// 查询导航菜单配置
export function nav_query_post(map, option) {
  return post(`${process.env.VUE_APP_HOMEPAGE}/nav/query`, map, option).then(
    response => response
  )
}

// 查询站点配置
export function siteConf_query_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/siteConf/query`,
    map,
    option
  ).then(response => response)
}

// 后管新增或修改查询
export function siteConf_queryDetail_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/siteConf/queryDetail`,
    map,
    option
  ).then(response => response)
}

// 策略列表
export function homepage_strategy_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/list`,
    map,
    option
  ).then(response => response)
}

// 运营位列表
export function homepage_strategy_operationposition_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/operationposition/list`,
    map,
    option
  ).then(response => response)
}

// 人群标签列表
export function homepage_strategy_tag_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/tag/list`,
    map,
    option
  ).then(response => response)
}

// 新增策略
export function homepage_strategy_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/add`,
    map,
    option
  ).then(response => response)
}

// 删除策略
export function homepage_strategy_delete_strategyId_delete(map, option) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/delete/${map.strategyId}`,
    map,
    option
  ).then(response => response)
}

// 策略详情
export function homepage_strategy_detail_strategyId_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/detail/${map.strategyId}`,
    map,
    option
  ).then(response => response)
}

// 编辑策略
export function homepage_strategy_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/edit`,
    map,
    option
  ).then(response => response)
}

// 策略修改顺序
export function homepage_strategy_modifySort_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/modifySort`,
    map,
    option
  ).then(response => response)
}

// 获取首页信息(To C)
export function homepage_getInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/getInfo`,
    map,
    option
  ).then(response => response)
}

// init（请无视）
export function homepage_strategy_init_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/strategy/init`,
    map,
    option
  ).then(response => response)
}

// 新增首页倒计时
export function homepage_material_homepagecountdown_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homepagecountdown/add`,
    map,
    option
  ).then(response => response)
}

// 删除首页倒计时
export function homepage_material_homepagecountdown_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homepagecountdown/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 首页倒计时详情
export function homepage_material_homepagecountdown_detail_materialId_get(
  map,
  option
) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homepagecountdown/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑首页倒计时
export function homepage_material_homepagecountdown_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homepagecountdown/edit`,
    map,
    option
  ).then(response => response)
}

// 首页倒计时列表
export function homepage_material_homepagecountdown_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/homepagecountdown/list`,
    map,
    option
  ).then(response => response)
}

// 新增top banner
export function homepage_material_topbanner_v1_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/add`,
    map,
    option
  ).then(response => response)
}

// 新增top banner
export function homepage_material_topbanner_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/add`,
    map,
    option
  ).then(response => response)
}

// 删除top banner
export function homepage_material_topbanner_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// top banner详情
export function homepage_material_topbanner_detail_materialId_get(map, option) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑top banner
export function homepage_material_topbanner_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/edit`,
    map,
    option
  ).then(response => response)
}

// top banner列表
export function homepage_material_topbanner_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/list`,
    map,
    option
  ).then(response => response)
}

// 删除top banner
export function homepage_material_topbanner_v1_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// top banner详情
export function homepage_material_topbanner_v1_detail_materialId_get(
  map,
  option
) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑top banner
export function homepage_material_topbanner_v1_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/edit`,
    map,
    option
  ).then(response => response)
}

// top banner列表
export function homepage_material_topbanner_v1_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/list`,
    map,
    option
  ).then(response => response)
}
